import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Td,
  Text,
  Tr,
  useDisclosure,
  HStack,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";

const UserCard = ({ name, email, balance, id, isBlock, OpenBlockModal, totalWalletBalance }) => {
  const navigate = useNavigate();
  const handleNaviagte = () => {
    navigate(`/admin/users/${id}`);
  }
  // const { isOpen, onOpen,  NewClose=onClose } = useDisclosure();
  return (
    <>
      <Tr >
        <Td pt={'0.7rem !important'} pb={'0.7rem !important'} borderBottom={"1px solid"} borderColor={"gray.700"} color="white">{name || "user"}</Td>
        <Td pt={'0.7rem !important'} pb={'0.7rem !important'} borderBottom={"1px solid"} borderColor={"gray.700"} color="white">{email}</Td>
        <Td pt={'0.7rem !important'} pb={'0.7rem !important'} borderBottom={"1px solid"} borderColor={"gray.700"} color="white">{balance || 0}</Td>
        <Td pt={'0.7rem !important'} pb={'0.7rem !important'} borderBottom={"1px solid"} borderColor={"gray.700"} color="white">{totalWalletBalance || 0}</Td>

        <Td pt={'0.7rem !important'} pb={'0.7rem !important'} borderBottom={"1px solid"} borderColor={"gray.700"}>
          <Text color={isBlock ? "red.400" : "green.400"} fontWeight="bold">
            {isBlock ? "Blocked" : "Active"}
          </Text>
        </Td>
        <Td pt={'0.7rem !important'} pb={'0.7rem !important'} borderBottom={"1px solid"} borderColor={"gray.700"}>
          <HStack spacing={2}>
            <Button
              _hover={{
                bg: "#319795",
                color: "white",
                borderColor: "#319795"
              }}
              color={"#319795"}
              bg={"gray.800"}
              w={"75px"}
              h={"2.35rem"}
              p={0}
              fontSize={"0.97rem"}
              border={"1px solid"}
              borderColor={"#319795"}
              onClick={() => OpenBlockModal(id, isBlock)}
            >
              {isBlock ? "Active" : "Block"}
            </Button>
            <Button
              _hover={{
                bg: "#319795",
                color: "white",
                borderColor: "#319795"
              }}
              color={"#319795"}
              bg={"gray.800"}
              w={"110px"}
              h={"2.35rem"}
              p={0}
              fontSize={"0.97rem"}
              border={"1px solid"}
              borderColor={"#319795"}
              onClick={() => navigate(`/admin/transaction?userId=${id}`)}
            >
              Transactions
            </Button>
          </HStack>
        </Td>
      </Tr>
    </>
  );
};

export default UserCard;
